import { ArrayParam, NumberParam } from "use-query-params";

export const INITIATIVE_DEFAULT_QUERY_PARAMS = {
  orderBy: ArrayParam,
  status: ArrayParam,
  projectTypeIds: ArrayParam,
  productCategoryIds: ArrayParam,
  page: NumberParam
};